
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Categoria } from 'src/app/model/categoria';

//const corsResolver=require('src/cors.js');



const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })
  export class CategoriaService {
    private url : string = `${environment.HOST}/api/categoria/`;
    private urlUpload : string = `${environment.HOST}/api`;
  //  private url : string = `api_servidor/api/categoria/`;
   // private urlUpload : string = `api_servidor/api`;
    constructor(
        private http : HttpClient,
        private router : Router
      ) { }

   
      
      


 getCategoria():Observable<Categoria[]>{

    return this.http.get<Categoria[]>(`${this.url}`);
 }


 getCategoriaById(idCategoria:number):Observable<Categoria[]>{
  return this.http.get<Categoria[]>(`${this.url}by-id/${idCategoria}`);
}

 

 nuevaCategoria(  idUsuario : number, descripcion : String,imagen : String) {
  return this.http.post(`${this.url}nueva-categoria/${idUsuario}/${descripcion}/${imagen}`, "");
}

modificaCategoria( idUsuario : number,idCategoria:number,descripcion:String ,imagen:String) {
  return this.http.post(`${this.url}modifica-categoria/${idUsuario}/${idCategoria}/${descripcion}/${imagen}`, "");
}


guardarImagen(form:FormData,tipoMedia:number ) {
  return this.http.post(`${this.urlUpload}/media/upload/${tipoMedia}`,form);
}


    }